<template>
<div v-if="emptyFields.is" class="emptyFields">
    Необходимо заполнить поля: 
    <a v-for="f in emptyFields.list" class="emptyFields__a" @click.stop.prevent="set_focus(f)">{{f.title}}</a>
</div>
</template>

<style lang="scss" src="./PersonForm.scss"></style>

<script setup>
import {computed, unref, ref} from 'vue'
import useTouristStore from '@/tourist/tourist-store.js'
import {fieldsInOrder} from '@/comp/useOrder.js'


const tstore=useTouristStore()

const props = defineProps({
    sid : String,
    personRef: { },
})



const emptyFields = computed(() => {
    const p = tstore.person( props.sid )

    let is = false
    const list = []
    const FIELDS = fieldsInOrder(p)

// в блоке "Необходимо заполнить поля" покзываем ПУСТЫЕ и невалидные поля
// если поле непусто и невалидно - мы увидимо ошибку в форме 

    for (let ff of FIELDS) {
        const rec =  p.vest.tests[ ff ]
        const field = p[ff]
        if ("" === field.val && !rec.valid) {
            const id = ff
            const title = field.title
            list.push( {id, title} )
        }
        if (list.length > 2) {
            break;
        }
    }

    is  = list.length > 0

    return {is, list}
})

const set_focus = ({id}) => {
    const el = unref( props.personRef )
//console.log('set_focus', el, id )
    if (el) {
        const child=el.querySelector(`#${id}`)
        if (child) {
            const forFocus = child.querySelector('.focusWhenEmpty')
            forFocus && forFocus.focus()
        }
    }
}

</script>
